import React from 'react';
import { Label, Row, Col, Button } from 'reactstrap';
import SelectAsyncComponent from '../../../../componentes/select/select-async.component';
import Switch from 'react-switch';
import '../../configuracao.style.css';

const ConfigRecebimentoPage = props => (
  <div>
    <div
      style={{
        height: `${props.altura}px`,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden'
      }}
    >
      {props.configs.map(conf => (
        <div key={conf.id} className='config-item'>
          <Row>
            <Col style={{ minWidth: '85%' }}>
              <Label>{conf.nome}</Label>
            </Col>
            <Col>
              <Switch
                onChange={e => {
                  props.toggleSwitch(conf.id, e);
                }}
                checked={conf.valor}
              />
            </Col>
          </Row>
          {conf.id === 4 && conf.valor && (
            <Row className='medico-exe-padrao'>
              <Label>Medico executante padrão: </Label>
              <div
                style={{
                  flex: 1,
                  height: '38px',
                  maxWidth: '500px'
                }}
              >
                <SelectAsyncComponent
                  placeholder='Medico executante padrão'
                  options={props.medicos}
                  onChange={event => {
                    props.setMedicoExecutante(event);
                  }}
                  value={props.medicoExecutante}
                  styles={{
                    width: '300px',
                    marginLeft: '15px',
                    marginTop: '7px'
                  }}
                />
              </div>
            </Row>
          )}
        </div>
      ))}
    </div>
    <Button
      color='primary'
      onClick={props.salvar}
      disabled={props.disabledSalvar()}
    >
      Gravar
    </Button>
  </div>
);

export default ConfigRecebimentoPage;



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/material/recebimento.page.js